export const width = window.innerWidth;
